var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.active)?_c('div',{staticClass:"loading-overlay"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"icon"}),(_vm.text)?_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.t(_vm.text)))]):_vm._e()])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }